import { TextField, styled } from '@mui/material';
import { memo } from 'react';

const SmallTextField: typeof TextField = props => <TextField autoComplete="off" size="small" {...props} />;

const StyledTextField: typeof TextField = styled(memo(SmallTextField))(() => ({
  '& .MuiInputLabel-root': { fontWeight: 'bold' },
  '& .MuiInputBase-input': { textTransform: 'uppercase' }
}));

export default StyledTextField;
